import { fetchAgentPresets, fetchAgentPresetById, fetchPublicAgentPresetById } from "./api";

// Query keys - export for cache invalidation from other modules
export const agentPresetQueryKeys = {
  agentPresets: ["agentPresets"] as const,
  fetchAgentPresets: () => [...agentPresetQueryKeys.agentPresets, "fetch"] as const,
  fetchAgentPresetById: (agentId: string) => [...agentPresetQueryKeys.agentPresets, "fetchById", agentId] as const,
  // 공개 모드용 쿼리 키 (캐시 분리)
  fetchPublicAgentPresetById: (agentId: string) => [...agentPresetQueryKeys.agentPresets, "fetchPublicById", agentId] as const,
};

// Alias for backward compatibility
const queryKeys = agentPresetQueryKeys;

export const agentPresetsQueryOptions = {
  fetchAgentPresets: () => ({
    queryKey: queryKeys.fetchAgentPresets(),
    queryFn: () => fetchAgentPresets(),
  }),
  fetchAgentPresetById: (agentId: string) => ({
    queryKey: queryKeys.fetchAgentPresetById(agentId),
    queryFn: () => fetchAgentPresetById(agentId),
  }),
  // 공개 모드용 쿼리 옵션 (인증 불필요)
  fetchPublicAgentPresetById: (agentId: string) => ({
    queryKey: queryKeys.fetchPublicAgentPresetById(agentId),
    queryFn: () => fetchPublicAgentPresetById(agentId),
  }),
} as const;